import React, { useMemo, useContext } from 'react';
import { first } from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  ValidatedPanel,
  TextTitle,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { propertyIs } from '@bingads-webui-campaign-react/form-error';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { isEmptyUrl, validateAdUrl } from '@bingads-webui-campaign-react/url-input-fluent';
import MobileFinalUrlImg from '../media/mobile-url.svg';
import { ValidatedMobileUrlWithoutCheckbox } from './mobile-url-with-custom-validation';

const nativeAdMobileFinalUrlsProp = propertyIs('MobileFinalUrls');
const ServerValidatedMobileFinalUrl = withControlErrorHandling(withUnvalidatedControlErrors(ValidatedMobileUrlWithoutCheckbox, { filter: nativeAdMobileFinalUrlsProp }));
const customizedValidation = (url, requiredUrlProtocolAndDomain, i18n, urlLengthLimit, customUrlProtocol) => {
  if (isEmptyUrl([url])) {
    return null;
  }
  return validateAdUrl(url, requiredUrlProtocolAndDomain, i18n, urlLengthLimit, customUrlProtocol);
};

export const MobileUrlSection = ({
  expand,
  mobileFinalUrls,
  ...rest
}) => {
  const i18n = useContext(I18nContext);
  const mobileFinalUrlValidationProps = useMemo(() => ({
    data: {
      MobileFinalUrls: mobileFinalUrls,
    },
    initialValue: {
      MobileFinalUrls: mobileFinalUrls,
    },
  }), [mobileFinalUrls]);
  const mobileFinalUrlDetails = useMemo(() => (isEmptyUrl(mobileFinalUrls) ? i18n.getString(_TL_('Mobile URL: None')) : first(mobileFinalUrls)), [i18n, mobileFinalUrls]);

  return (
    <ValidatedPanel
      key="mobile-final-url"
      title={<TextTitle titleKey={_TL_('Mobile URL')} topicKey="pop_BA_CampaignCreate_AudAds_MobileURL" details={mobileFinalUrlDetails} icon={MobileFinalUrlImg} />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'mobile-final-url',
      }}
      {...rest}
    >
      <ServerValidatedMobileFinalUrl
        i18n={i18n}
        validationProps={mobileFinalUrlValidationProps}
        validateOnRender
        customizedValidation={customizedValidation}
        isControlledOutside
      />
    </ValidatedPanel>
  );
};

MobileUrlSection.propTypes = {
  expand: PropTypes.func.isRequired,
  permissions: PropTypes.shape({}).isRequired,
  mobileFinalUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
};
